import { Box } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { toast } from "../../../utils/snackbarHelper";
import { FlexRow } from "../../../components/shared/layout/Flex";
import { StatusTagChip } from "../../../components/shared/StatusTag/StatusTagChip";
import { LightTooltip } from "../../../components/shared/LightTooltip";
import { useSelectedServiceCenter } from "../../../hooks/useSelectedServiceCenter";
import { DaylightDateFormat } from "../../../constants/DaylightDateFormat";

interface ReadOnlyStatusTagProps {
  /** Status displayed in the tag. */
  status: string;
  /** Whether the status is planned (green) or not */
  isPlanned?: boolean;
  /** Warning message to display when clicked */
  warningMessage: string;
  /** Last time the status was changed */
  statusLastChangedTime?: Dayjs | null;
}

export const ReadOnlyStatusTag = ({
  status,
  isPlanned = true,
  warningMessage,
  statusLastChangedTime,
}: ReadOnlyStatusTagProps) => {
  const [serviceCenter] = useSelectedServiceCenter();

  const handleOnClick = () => {
    toast(warningMessage, {
      variant: "warning",
    });
  };

  const hasValidTimestamp =
    statusLastChangedTime &&
    serviceCenter.timeZone &&
    dayjs(statusLastChangedTime).isValid();

  const formattedDateTime = hasValidTimestamp
    ? dayjs(statusLastChangedTime)
        .tz(serviceCenter.timeZone)
        .format(DaylightDateFormat.DATE_TIME_LONG)
    : null;

  const chipElement = (
    <Box>
      <StatusTagChip
        isPlanned={isPlanned}
        status={status}
        onClick={handleOnClick}
      />
    </Box>
  );

  const chip =
    hasValidTimestamp && formattedDateTime ? (
      <LightTooltip
        title={`Status updated: ${formattedDateTime}`}
        placement="top"
      >
        {chipElement}
      </LightTooltip>
    ) : (
      chipElement
    );

  return <FlexRow style={{ alignItems: "center", gap: "6px" }}>{chip}</FlexRow>;
};
